import React from 'react'

const Fifty_five = () => {
    return (
        <div className='container'>
            <h1>Split string by space into words</h1>
            <div className='container'>
            Split a string into tokens - strtok <br />
            split a string into several tokens using strtok function. To split a 
            string we need delimiters - delimiters are characters which will be used to split the string. <br />
            strtok returns NULL when there is no more tokens, i.e., the whole string is split. This can 
            be utilized to know when to stop calling strtok <br />
            </div>
            <div className='containers'>
           <code className='library'> #include</code> &lt;stdio.h &gt;<br/>
           <code className='library'>#include</code> &lt;string.h &gt;<br/>

           <code className='keywords'>int</code> main()
&#123;<br/>
<code className='keywords'>char</code> str[] = "strtok needs to be called several times to split a string";<br/>
<code className='keywords'>int </code>init_size = strlen(str);<br/>
<code className='keywords'>char </code>delim[] = " ";<br/>

<code className='keywords'>char</code> *ptr = strtok(str, delim);<br/>

<code className='library'>while</code>(ptr != NULL)
	&#123;<br/>
	<code className='library'>	printf</code>("'%s'\n", ptr);<br/>
		ptr = strtok(NULL, delim);<br/>
	&#125;<br/>

	<code className='comment'>/* This loop will show that there are zeroes in the str after tokenizing */ </code><br/>
	<code className='library'>for</code> (int i = 0; i &lt; init_size; i++)
	&#123;<br/>
		printf("%d ", str[i]);<br/> <code className='comment'> /* Convert the character to integer, in this case
							        the character's ASCII equivalent */</code><br/>
	&#125;<br/>
	<code className='library'>printf</code>("\n");<br/>

	<code className='library'>return </code>0;<br/>
&#125;<br/>
            </div>
        </div>
    )
}

export default Fifty_five
